import {setLoading} from "../../common/Loader/slice";
import requestUtil from "../../../helpers/requestUtil";
import { 
    getEmployerUserDetailSuccess,
    getEmployerUserDetailError,
    updateProfileInfoSuccess, 
    updateProfileInfoError 
 } from "./slice";


export function getEmployerUserDetail(url, employerUserId) {
    return async (dispatch) => {
        dispatch(setLoading(true));
        requestUtil(`${url}/EmployerUsers/getemployeruserdetail/${employerUserId}/`, "GET")
        .then((response) => {
                dispatch(getEmployerUserDetailSuccess(response));
            }).catch((error) => {
                dispatch(getEmployerUserDetailError(error.message));
                dispatch(setLoading(false));
            });
        dispatch(setLoading(false));
    };
}

 export function updateProfileInfo(url, profileInfo) {
    return async (dispatch) => {
        dispatch(setLoading(true));
        requestUtil(`${url}/EmployerUsers/updateemployeruser`, "POST", profileInfo)
        .then((response) => {
                dispatch(updateProfileInfoSuccess(response.message));
            }).catch((error) => {
                dispatch(updateProfileInfoError(error.message));
                dispatch(setLoading(false));
            });
        dispatch(setLoading(false));
    };
}